import React from "react";

import { AdditionalEntryDateClassificationRuleContainer } from "../../../containers";

const AdditionalEntryDateClassificationRule = (props) => {
  return <AdditionalEntryDateClassificationRuleContainer {...props} />;
};

export default AdditionalEntryDateClassificationRule;
